/* ========================================================================
   HERMES Lumbeard v1b — Barbershop Industrial Heritage interactions
   Anim set: preloader counter 020% · BlurText · letter reveal · count-up ·
             spotlight cursor reveal · horizontal scroll-scrub · word swap ·
             stagger fade-rise · variant sync · anti-spy · desktop-block ·
             Releasit integration
   ======================================================================== */
(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────────────── */
  var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var section = $('.hm-lum');
  if (!section) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) document.body.classList.add('is-touch');

  /* ════════════════════════════════════════════════════════════
     0) DESKTOP BLOCK + ANTI-SPY
     ════════════════════════════════════════════════════════════ */
  var caught = $('.hm-lum-caught');
  var desktopBlocked = false;

  function isDesktop() {
    return (
      window.matchMedia('(min-width: 1024px)').matches ||
      (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !isTouch)
    );
  }

  function showCaught(mode) {
    if (!caught) return;
    caught.classList.remove('is-mode-spy', 'is-mode-desktop');
    caught.classList.add('is-active', 'is-mode-' + mode);
    if (mode === 'desktop') desktopBlocked = true;
  }

  // Desktop block (opt-in via .hm-lum--desktop-block modifier)
  if (section.classList.contains('hm-lum--desktop-block') && isDesktop()) {
    showCaught('desktop');
    // Stop further JS init — return early after critical setup
    return;
  }

  // Anti-spy (opt-in via .hm-lum--anti-spy modifier)
  if (section.classList.contains('hm-lum--anti-spy')) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      showCaught('spy');
    });
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      var blockedSingle = ['f12'];
      if (blockedSingle.indexOf(key) > -1) { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) {
        e.preventDefault(); showCaught('spy'); return;
      }
      if ((e.ctrlKey || e.metaKey) && (key === 'u' || key === 's' || key === 'p')) {
        e.preventDefault(); showCaught('spy'); return;
      }
    });

    // DevTools delta detection
    setInterval(function () {
      var delta = Math.abs(window.outerWidth - window.innerWidth) + Math.abs(window.outerHeight - window.innerHeight);
      if (delta > 200) showCaught('spy');
    }, 1500);

    // Drag block on media
    $$('.hm-lum img, .hm-lum video').forEach(function (el) {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ════════════════════════════════════════════════════════════
     1) PRELOADER counter 000 → 020 + rotating words
     ════════════════════════════════════════════════════════════ */
  (function preloader() {
    var pre  = $('#hm-lum-preloader');
    var ctr  = $('#hm-lum-counter');
    var bar  = $('#hm-lum-bar');
    var wrap = $('#hm-lum-words');
    if (!pre || !ctr || !bar) return;

    var target = 20; // 20% = MINOXIDIL concentration
    var duration = 2400;
    var start = performance.now();

    function tick(t) {
      var p = Math.min(1, (t - start) / duration);
      var ease = 1 - Math.pow(1 - p, 3);
      var n = Math.floor(ease * target);
      ctr.textContent = String(n).padStart(3, '0');
      bar.style.width = (ease * 100) + '%';
      if (p < 1) requestAnimationFrame(tick);
      else {
        setTimeout(function () {
          pre.classList.add('is-done');
        }, 380);
      }
    }
    requestAnimationFrame(tick);

    // Rotating words
    if (wrap) {
      var pwords = $$('.hm-lum-pw', wrap);
      var idx = 0;
      setInterval(function () {
        pwords[idx].classList.remove('active');
        idx = (idx + 1) % pwords.length;
        pwords[idx].classList.add('active');
      }, 500);
    }
  })();

  /* ════════════════════════════════════════════════════════════
     2) BLUR-TEXT word-by-word reveal (hero headline)
     ════════════════════════════════════════════════════════════ */
  (function blurText() {
    $$('.hm-lum-blur-text').forEach(function (el) {
      var src = el.getAttribute('data-blur-text') || '';
      el.textContent = '';
      var words = src.split(/\s+/).filter(Boolean);
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'hm-lum-blur-text__word';
        span.style.setProperty('--d', (0.15 + i * 0.10) + 's');
        span.textContent = w;
        el.appendChild(span);
      });
    });
    // Trigger on load
    setTimeout(function () {
      $$('.hm-lum-blur-text__word').forEach(function (w) { w.classList.add('is-in'); });
    }, 900);
  })();

  /* ════════════════════════════════════════════════════════════
     3) LETTER-BY-LETTER reveal (pull-quote)
     ════════════════════════════════════════════════════════════ */
  (function letterReveal() {
    $$('[data-letter-reveal]').forEach(function (el) {
      var src = el.getAttribute('data-source') || '';
      el.innerHTML = '';
      // Preserve <em> by tokenizing
      var rx = /(<em>[^<]*<\/em>)|(\S)|(\s+)/g;
      var m, i = 0;
      while ((m = rx.exec(src)) !== null) {
        if (m[1]) {
          // em block — wrap each letter inside it
          var emTxt = m[1].replace(/<\/?em>/g, '');
          var em = document.createElement('em');
          for (var k = 0; k < emTxt.length; k++) {
            var ch = emTxt[k];
            if (ch === ' ') { em.appendChild(document.createTextNode(' ')); continue; }
            var s = document.createElement('span');
            s.className = 'hm-lum-letter';
            s.style.setProperty('--d', (i * 0.018) + 's');
            s.textContent = ch;
            em.appendChild(s);
            i++;
          }
          el.appendChild(em);
        } else if (m[2]) {
          var sp = document.createElement('span');
          sp.className = 'hm-lum-letter';
          sp.style.setProperty('--d', (i * 0.018) + 's');
          sp.textContent = m[2];
          el.appendChild(sp);
          i++;
        } else if (m[3]) {
          el.appendChild(document.createTextNode(m[3]));
        }
      }

      // Reveal on viewport enter
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            $$('.hm-lum-letter', el).forEach(function (l) { l.classList.add('is-in'); });
            io.disconnect();
          }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     4) COUNT-UP stats on viewport enter
     ════════════════════════════════════════════════════════════ */
  (function countUp() {
    $$('.hm-lum-stat__num').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      if (isNaN(target) || target === 0) return;
      el.dataset.original = el.textContent;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var dur = 1600;
          var start = performance.now();
          function tick(t) {
            var p = Math.min(1, (t - start) / dur);
            var ease = 1 - Math.pow(1 - p, 3);
            var n = Math.floor(ease * target);
            el.textContent = n + suffix;
            if (p < 1) requestAnimationFrame(tick);
            else el.textContent = target + suffix;
          }
          requestAnimationFrame(tick);
          entry.target.parentElement.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     5) SPOTLIGHT cursor reveal — "Tu folículo está dormido"
     ════════════════════════════════════════════════════════════ */
  (function spotlight() {
    var sp = $('#hm-lum-spotlight');
    if (!sp) return;

    function setPos(x, y) {
      var rect = sp.getBoundingClientRect();
      var mx = ((x - rect.left) / rect.width)  * 100;
      var my = ((y - rect.top)  / rect.height) * 100;
      sp.style.setProperty('--mx', mx + '%');
      sp.style.setProperty('--my', my + '%');
    }

    sp.addEventListener('mouseenter', function () { sp.classList.add('is-active'); });
    sp.addEventListener('mouseleave', function () { sp.classList.remove('is-active'); });
    sp.addEventListener('mousemove',  function (e) { setPos(e.clientX, e.clientY); });

    sp.addEventListener('touchstart', function (e) {
      sp.classList.add('is-active');
      var t = e.touches[0]; if (t) setPos(t.clientX, t.clientY);
    });
    sp.addEventListener('touchmove', function (e) {
      var t = e.touches[0]; if (t) setPos(t.clientX, t.clientY);
    });
    sp.addEventListener('touchend', function () {
      setTimeout(function () { sp.classList.remove('is-active'); }, 600);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     6) HORIZONTAL SCROLL-SCRUB timeline progress
     ════════════════════════════════════════════════════════════ */
  (function timelineScrub() {
    var rail  = $('#hm-lum-timeline-rail');
    var track = $('#hm-lum-timeline-track');
    var prog  = $('#hm-lum-timeline-progress');
    if (!rail || !track || !prog) return;

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var p = max <= 0 ? 100 : Math.min(100, Math.max(10, (rail.scrollLeft / max) * 100));
      prog.style.setProperty('--p', p + '%');

      // Mark active node closest to center
      var center = rail.scrollLeft + rail.clientWidth / 2;
      var nodes = $$('.hm-lum-timeline__node', track);
      var closest = null; var closestDist = Infinity;
      nodes.forEach(function (n) {
        var nc = n.offsetLeft + n.offsetWidth / 2;
        var d  = Math.abs(nc - center);
        if (d < closestDist) { closestDist = d; closest = n; }
      });
      nodes.forEach(function (n) { n.classList.toggle('is-active', n === closest); });
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* ════════════════════════════════════════════════════════════
     7) STAGGER FADE-RISE on viewport enter (generic)
     ════════════════════════════════════════════════════════════ */
  (function fadeRise() {
    var ioFR = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          ioFR.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    $$('.hm-lum-stat, .hm-lum-timeline__node, .hm-lum-bullets li, .hm-lum-bento__cell').forEach(function (el) {
      ioFR.observe(el);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     8) VARIANT SELECTOR sync (variant_id + price + Releasit ATC)
     ════════════════════════════════════════════════════════════ */
  (function variantSync() {
    var wrap = $('[data-hm-lum-variants]');
    if (!wrap) return;

    var jsonEl = $('[data-hm-lum-variants-json]', wrap);
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}

    var optionGroups = $$('.hm-lum-hero__variant-options', wrap);
    var optionsCount = optionGroups.length;
    var selected = new Array(optionsCount);

    // Seed from active swatches
    optionGroups.forEach(function (grp, i) {
      var act = $('.hm-lum-variant-opt--active', grp);
      selected[i] = act ? act.getAttribute('data-option-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        for (var i = 0; i < optionsCount; i++) {
          if (selected[i] && opts[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      // Variant id input
      var inp = $('[data-hm-lum-variant-input]');
      if (inp) inp.value = v.id;

      // Hero price card + final + sticky bar
      var nowEl = $('.hm-lum-hero__price-now');
      var nowFinal = $('.hm-lum-final__now');
      var stickyNow = $('.hm-lum-sticky-cta__now');
      if (v.price && typeof v.price === 'number') {
        var price = formatCOP(v.price);
        if (nowEl)     nowEl.textContent     = price;
        if (nowFinal)  nowFinal.textContent  = price;
        if (stickyNow) stickyNow.textContent = price;
      }

      // Releasit ATC items
      window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
    }

    function formatCOP(cents) {
      // Shopify gives prices in cents
      var v = cents / 100;
      return '$' + v.toLocaleString('es-CO', { maximumFractionDigits: 0 });
    }

    optionGroups.forEach(function (grp, gIdx) {
      $$('.hm-lum-variant-opt', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.hm-lum-variant-opt', grp).forEach(function (b) { b.classList.remove('hm-lum-variant-opt--active'); });
          btn.classList.add('hm-lum-variant-opt--active');
          selected[gIdx] = btn.getAttribute('data-option-value');
          var v = findVariant();
          if (v) applyVariant(v);
        });
      });
    });
  })();

  /* ════════════════════════════════════════════════════════════
     9) RELEASIT INTEGRATION — proxy hero CTA, move button to slot
     ════════════════════════════════════════════════════════════ */
  (function releasit() {
    var slot = $('.hm-lum-cod-slot');
    var heroCta = $('[data-hm-lum-cta-proxy]');
    var mainCta = $('[data-hm-lum-main-cta]');

    // Hero CTA → trigger main CTA (Releasit hook button) — opens modal directly
    if (heroCta) {
      heroCta.addEventListener('click', function (e) {
        var rsiBtn = document.querySelector('._rsi-buy-now-button, #_rsi-buy-now-button-overwrite, ._rsi-buy-now-button-floating');
        if (rsiBtn) {
          e.preventDefault();
          rsiBtn.click();
          return;
        }
        if (mainCta) {
          e.preventDefault();
          mainCta.click();
        }
      });
    }

    // Poll for Releasit injection (max 20s, every 500ms)
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var rsiBtn = document.querySelector('._rsi-buy-now-button, #_rsi-buy-now-button-overwrite');
      var floating = document.querySelector('._rsi-buy-now-button-floating');

      if (rsiBtn) {
        clearInterval(poll);
        console.info('[HERMES lumbeard-v1] Releasit button detected — wiring hero CTA.');
      } else if (floating) {
        clearInterval(poll);
        console.info('[HERMES lumbeard-v1] Releasit floating button detected.');
      } else if (attempts > 40) {
        clearInterval(poll);
        console.warn('[HERMES lumbeard-v1] Releasit not detected — verify Dropi metafield + Releasit dashboard config.');
      }
    }, 500);
  })();

  /* ════════════════════════════════════════════════════════════
     10) Hide scroll-hint after small scroll
     ════════════════════════════════════════════════════════════ */
  (function scrollHint() {
    var hint = $('.hm-lum-hero__scrollhint');
    if (!hint) return;
    var hide = function () {
      if (window.scrollY > 80) {
        hint.style.opacity = '0';
        window.removeEventListener('scroll', hide);
      }
    };
    window.addEventListener('scroll', hide, { passive: true });
  })();

  /* ════════════════════════════════════════════════════════════
     11) STICKY CTA HERMES — siempre visible mientras scroll mobile.
         Reemplaza visualmente el Releasit floating (que ocultamos via CSS).
         Click sticky → dispara modal Releasit (idéntico al CTA hero).
         Hide cuando final-CTA está en view (evitar duplicación con CTA en flujo).
     ════════════════════════════════════════════════════════════ */
  (function stickyCta() {
    var sticky    = $('.hm-lum-sticky-cta');
    var heroCta   = $('.hm-lum-hero__cta');
    var finalSec  = $('#hm-lum-cta-final');
    if (!sticky || !heroCta) return;

    // Hide Releasit floating dinámicamente (por si CSS no atrapa una clase nueva)
    function killFloating() {
      $$('[class*="_rsi-buy-now"][class*="floating"], ._rsi-buy-now-button-floating, [class*="_rsi-floating"]').forEach(function (el) {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
      });
    }
    killFloating();
    var killPoll = setInterval(killFloating, 500);
    setTimeout(function () { clearInterval(killPoll); }, 24000);

    // Show sticky cuando hero CTA sale del viewport
    var ioHero = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
        } else {
          sticky.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1 });
    ioHero.observe(heroCta);

    // Hide sticky cuando final-CTA está visible (final tiene su propio CTA en flujo)
    if (finalSec) {
      var ioFinal = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-final-cta-visible');
          } else {
            section.classList.remove('is-final-cta-visible');
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40% 0px' });
      ioFinal.observe(finalSec);
    }

    // Click sticky → abre modal Releasit (idéntico al click del CTA hero)
    var stickyBtn = $('.hm-lum-sticky-cta__btn', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // Buscar buy-now button NO-floating (ya ocultamos floating)
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { rsiBtn.click(); return; }
        var mainCta = document.querySelector('[data-hm-lum-main-cta]');
        if (mainCta) { mainCta.click(); return; }
        finalSec && finalSec.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  /* ── End ─────────────────────────────────────────────────────────── */
  console.info('[HERMES lumbeard-v1] Section initialized.');
})();
